import lang from './_lang'
import invoice from './invoice'
import thirdParty from './thirdParty'
import agreements from './agreements'
import invoices from './invoices'
import search from './search/index'
import shared from './shared/index'
import views from './views/index'
import _import from './import'
import validations from './validations'
import config from './config'
import charts from './charts'
import signin from './signin'
import support from './support'
import login from './login'
import multicompany from './multicompany'
import footer from './footer'
import menus from './menus'

export default {
  ...lang,
  invoice,
  invoices,
  thirdParty,
  search,
  shared,
  views,
  agreements,
  import: _import,
  validations,
  config,
  charts,
  signin,
  support,
  login,
  multicompany,
  footer,
  menus
}